<!--
/*
 * This file is part of peacohrm Inc
 *
 * Copyright (C) 2020 onwards peacohrm Inc
 *
 * This program is free software; you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation; either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see  http://www.gnu.org/licenses
 */
-->

<template>
  <g transform="matrix(2.6906, 0, 0, 2.4145, -1911.572388, -1913.391968)">
    <path
      d="M751.157,908.377h-31.521c-3.31,0-5.995-2.685-5.995-5.995V801.996c0-3.312,2.685-5.996,5.995-5.996h25.424 c3.26,0,5.921,2.604,5.994,5.863l0.103,4.605V908.377L751.157,908.377z"
    />
    <path
      d="M867.548,923.739c-15.131,0-40.775,0-40.775,0s1.458,7.302,5.521,39.327C835.748,990.283,816.745,996,804.466,996 l-41.794-99.999v-87.216l21.421-5.784c9.838-2.657,19.989-4.004,30.179-4.004h29.068c11.352,0,21.403,7.373,24.826,18.197 c9.536,30.142,19.473,61.532,23.368,73.899C898.183,912.198,882.686,923.739,867.548,923.739z"
    />
  </g>
</template>
